export default function initStickyNav() {
  const header = document.querySelector('.header');
  const topBar = document.querySelector('.top-bar');
  let lastScrollY = window.scrollY;
  let isSticky = false;
  let isHidden = false;
  let scrollDeltaDown = 0;

  function handleScroll() {
    const currentScrollY = window.scrollY;
    const topBarHeight = topBar?.offsetHeight || 43;
    const isDesktop = window.innerWidth >= 768;

    if (currentScrollY <= topBarHeight) {
      header.classList.remove('header--sticky');
      isSticky = false;
      header.classList.remove('header--hidden');
      isHidden = false;

      if (isDesktop) {
        const shiftX = '-50%';
        const shiftY = -currentScrollY;
        header.style.transform = `translate(${shiftX}, ${shiftY}px)`;
      } else {
        header.style.transform = `translateY(${-currentScrollY}px)`;
      }

      scrollDeltaDown = 0;
    } else {
      if (!isSticky) {
        header.classList.add('header--sticky');
        isSticky = true;
        header.style.transform = '';
      }
      if (currentScrollY > lastScrollY) {
        const delta = currentScrollY - lastScrollY;
        scrollDeltaDown += delta;
        if (scrollDeltaDown > 150 && !isHidden) {
          header.classList.add('header--hidden');
          isHidden = true;
        }
      } else {
        const delta = lastScrollY - currentScrollY;
        scrollDeltaDown = 0;
        if (delta > 10 && isHidden) {
          header.classList.remove('header--hidden');
          isHidden = false;
        }
      }
    }

    lastScrollY = currentScrollY;
  }

  function handleResize() {
    if (window.innerWidth < 768) {
      header.classList.remove('header--sticky', 'header--hidden');
      isSticky = false;
      isHidden = false;
      header.style.transform = '';
      lastScrollY = window.scrollY;
      scrollDeltaDown = 0;
    }
  }

  window.addEventListener('scroll', handleScroll, { passive: true });
  window.addEventListener('resize', handleResize);
  handleScroll();
  handleResize();
}
